
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcToggletip as ObcToggletipElement} from '@oicl/openbridge-webcomponents/dist/components/toggletip/toggletip.js';
 
 
 

 
 export const ObcToggletip = createComponent({
   react: React,
   tagName: 'obc-toggletip',
   elementClass: ObcToggletipElement,
   events: {
     
     onPrimaryAction: 'primary-action' as EventName<CustomEvent>,
     onSecondaryAction: 'secondary-action' as EventName<CustomEvent>,
   }
  });
 
 